import type { TFunction } from 'i18next';

import { severityLabel } from '../../constants/labels';
import type { FeedItem } from '../../types/domain.types';

export const announceText = (t: TFunction, item: FeedItem | null): string =>
  item === null
    ? ''
    : t('closeTheLoop.inApp.announce', '{{severity}}: {{title}}. It stays in Recent alerts.', {
        severity: severityLabel(t, item.severity),
        title: item.issueTitle ?? item.title,
      });
